import React, { ReactNode } from "react";
import classNames from "classnames";
import Registry from "../../../../../base-registry";
import { TicketItem } from "../../../../../contexts/ticket-state";
import ExpandingSection from "../../../../expanding-section/ExpandingSection";
import SortableList from "../../../../theme/sortable/SortableList";
import Styles from "../TicketDetails.module.scss";

export interface TicketProperties {
    ticket: TicketItem;
    isMinimized: boolean;
    onToggleExpand: (props: ({ isExpanded: boolean })) => void;
    isReadOnly: boolean;
    metricPathPrefix: string[];
}

export interface SectionRegistry {
    sectionId: string;
    label: string;
    component: (details: TicketProperties) => ReactNode;
}

export const sectionRegistry = new Registry<SectionRegistry>();

export interface DetailSectionProps {
    title: ReactNode;
    isMinimized: boolean;
    children: ReactNode;
    onToggleExpand: (props: ({ isExpanded: boolean })) => void;
    className?: string;
}

export function DetailSection({
    title,
    isMinimized,
    children,
    onToggleExpand,
    className,
}: DetailSectionProps) {
    return (
        <ExpandingSection
            title={(
                <SortableList.Listener className="detail-draggable">
                    {title}
                </SortableList.Listener>
            )}
            defaultExpanded={!isMinimized}
            className={Styles["details-section-body"]}
            cardClassName={classNames(Styles["details-section"], className)}
            onCollapsed={() => onToggleExpand({ isExpanded: false })}
            onExpanded={() => onToggleExpand({ isExpanded: true })}
            defaultCardClassName=" "
        >
            {children}
        </ExpandingSection>
    );
}
DetailSection.defaultProps = {
    className: undefined,
};

export function DetailRow({
    title,
    children,
    className,
    description,
}: {
    title: ReactNode;
    children: ReactNode;
    description?: string;
    className?: string;
}) {
    return (
        <div className={Styles["detail-row"]} title={description}>
            <div className={Styles["details-row-title"]}>
                {title}
            </div>
            <div className={classNames(Styles["details-row-value"], className)}>
                {children}
            </div>
        </div>
    );
}
DetailRow.defaultProps = {
    className: "",
    description: undefined,
};
